import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-10 text-gray-400"
}

import { computed } from "vue";
import { Task } from "@/types/v2";
import { useUsersStore } from "@/stores/v2/";
import { useTask } from "@/composables/tasks/useTask";
import { buildTaskDependencyContext } from "@/utils/v2/tasks/dependencies";
import { useTasksStore } from "@/stores/v2";

import TaskStartModal from "@/components/v2/Dashboard/Tasks/Modals/TaskStartModal.vue";
import TaskItem from "@/components/v2/Dashboard/Tasks/Lists/TaskListItem.vue";

interface TasksListProps {
  tasks: Task[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TasksList',
  props: {
    tasks: {}
  },
  setup(__props: any) {



const { showStartTaskModal, selectedTask, handleSelectTask, handleStartTask } = useTask();
const tasksStore = useTasksStore();
const dependencyContextByTaskKey = computed(() =>
  buildTaskDependencyContext(tasksStore.getTasks)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (task) => {
      return (_openBlock(), _createBlock(TaskItem, {
        onClick: ($event: any) => (_unref(handleSelectTask)(task)),
        key: task.key,
        currentUser: _unref(useUsersStore)().getCurrentUser,
        task: task,
        dependencyContext: dependencyContextByTaskKey.value[task.key]
      }, null, 8, ["onClick", "currentUser", "task", "dependencyContext"]))
    }), 128)),
    (_ctx.tasks.length === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, " No tasks in this tab... "))
      : _createCommentVNode("", true),
    (_unref(showStartTaskModal) && _unref(selectedTask))
      ? (_openBlock(), _createBlock(TaskStartModal, {
          key: 1,
          show: _unref(showStartTaskModal),
          task: _unref(selectedTask),
          currentUser: _unref(useUsersStore)().getCurrentUser,
          onStart: _unref(handleStartTask),
          onClose: _cache[0] || (_cache[0] = ($event: any) => (showStartTaskModal.value = false))
        }, null, 8, ["show", "task", "currentUser", "onStart"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})